export default "__VITE_ASSET__BzerY9R5__"